export default "__VITE_ASSET__CgSryBmw__"